import script from "./WhatsApp.vue?vue&type=script&setup=true&lang=js"
export * from "./WhatsApp.vue?vue&type=script&setup=true&lang=js"

import "./WhatsApp.vue?vue&type=style&index=0&id=fc253958&lang=css"

const __exports__ = script;

export default __exports__